import { SuggestionItem } from '../types';

export const CLUSTER_INSIGHTS_SUGGESTIONS: SuggestionItem[] = [
  {
    id: 'insights.all',
    label: 'Cluster Insights (All)',
    description: 'All cluster insights/issues in the last hour',
    keywords: ['cluster insights', 'insights', 'cluster issues', 'health insights'],
    category: 'cluster-insights',
    queryId: 'GET_INSIGHTS',
    fieldPath: 'getInsights',
    formatter: (raw) => {
      const insights = raw?.record?.insights;
      if (!insights || insights.length === 0) return '✅ No cluster insights/issues found.';
      const rows = insights.slice(0, 10).map((i: any) =>
        `- **${i.displayName || i.name || 'Insight'}** (${i.priority || 'N/A'}) — Status: ${i.status || 'Unknown'}`
      );
      return [`## 🔍 Cluster Insights (${insights.length} found)`, ...rows].join('\n');
    },
  },
  {
    id: 'insights.critical',
    label: 'Critical Insights',
    description: 'High-severity cluster insights only',
    keywords: ['critical insights', 'high severity', 'critical issues', 'severe'],
    category: 'cluster-insights',
    queryId: 'GET_INSIGHTS',
    fieldPath: 'getInsights',
    formatter: (raw) => {
      const insights = raw?.record?.insights;
      if (!insights || insights.length === 0) return '✅ No insights found.';
      const critical = insights.filter((i: any) =>
        i.priority?.toLowerCase() === 'high' || i.priority?.toLowerCase() === 'critical'
      );
      if (critical.length === 0) return '✅ No critical insights found.';
      const rows = critical.map((i: any) =>
        `- **${i.displayName || i.name || 'Insight'}** — Status: ${i.status || 'Unknown'}`
      );
      return [`**Critical Insights (${critical.length}):**`, ...rows].join('\n');
    },
  },
  /* Commented out per request — hidden from the "/" suggestions menu.
  {
    id: 'healthSummary.clusterHealth',
    label: 'Cluster Health Summary',
    description: 'Cluster health overview from insights tab',
    keywords: ['cluster health summary', 'health summary', 'cluster health overview'],
    category: 'cluster-insights',
    queryId: 'CLUSTER_HEALTH_SUMMARY',
    fieldPath: 'clusterHealth',
    formatter: (v) => {
      if (!v) return '⚠️ No cluster health data available.';
      return `**Cluster Health Summary:**\n\`\`\`json\n${JSON.stringify(v, null, 2).slice(0, 500)}\n\`\`\``;
    },
  },
  {
    id: 'healthSummary.nodeCount',
    label: 'Number of Nodes',
    description: 'Total number of nodes from cluster health summary',
    keywords: ['number of nodes', 'node count', 'total nodes'],
    category: 'cluster-insights',
    queryId: 'CLUSTER_HEALTH_SUMMARY',
    fieldPath: 'nodes',
    formatter: (v) => `**Number of Nodes:** ${v ?? 'N/A'}`,
  },
  {
    id: 'healthSummary.clusterStats',
    label: 'Cluster Stats',
    description: 'Cluster statistics from health summary',
    keywords: ['cluster stats', 'cluster statistics'],
    category: 'cluster-insights',
    queryId: 'CLUSTER_HEALTH_SUMMARY',
    fieldPath: 'clusterStats',
    formatter: (v) => {
      if (!v) return '⚠️ No cluster stats available.';
      return `**Cluster Stats:**\n\`\`\`json\n${JSON.stringify(v, null, 2).slice(0, 500)}\n\`\`\``;
    },
  },
  {
    id: 'healthSummary.workloadClassification',
    label: 'Workload Classification',
    description: 'Domain workload classification from insights metadata',
    keywords: ['workload', 'classification', 'workload type', 'workload classification'],
    category: 'cluster-insights',
    queryId: 'CLUSTER_HEALTH_SUMMARY',
    fieldPath: 'workloadClassification',
    formatter: (v) => {
      if (!v) return '⚠️ No workload classification available.';
      return `**Workload Classification:**\n\`\`\`json\n${JSON.stringify(v, null, 2).slice(0, 300)}\n\`\`\``;
    },
  },
  */
];
